export default __webpack_public_path__ + "bc44f55030dcabb3f33ddf9906740e64.png";